import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import GameTypeIcon from  '../../assets/images/Strategy Game.png'
import { createTransactionTypeService, getTransactionTypeService, updateTransactionService } from '../../services/transaction.service';
import { useDispatch } from 'react-redux';
import { setIsLoading, setToastMessage } from "../../reducers/common.reducer";

const Transaction = () => {

    const [showEdit, setShowEdit] = useState(false);  //for show edit modal
    const [transactionTypeData, setTransactionTypeData] = useState([]);  //Get TransactionData from API
    const [inputModal, setInputModal] = useState({});  //for edit modal
    const [errors, setErrors] = useState({});  //for validation
    const [inputData, setInputData] = useState({
        transactionType: ''
      });   //for new Transaction input

    const dispatch = useDispatch();

    //newTransaction input Reset
    const formReset = () => {
        setShowEdit(false);
        setInputData({
            transactionType: ''
          });
          setErrors({});
      }

    //editTransaction modal show/hide
    const handleEditClick = (item) => {
        setShowEdit(!showEdit);
        setInputModal(item);
    }

    //newTransaction form submit and validation
    let handleSubmit = (event) => {
      event.preventDefault();
      const validateErrors = validate();
      if(Object.keys(validateErrors).length === 0) {
        createAction();
      }
      else {
        setErrors(validateErrors);
      }
    }

    //editTransaction modal submit and validation
    let handleSubmitModal = (event) => {
      event.preventDefault();
      const validateErrors = validate();

      if(Object.keys(validateErrors).length === 0) {
        createAction();
      }
      else {
        setErrors(validateErrors);
      }
    }


    //validation for newTransaction and editTransaction input
    const validate = () => {
        let errors = {};
        if(showEdit) {
            if(!inputModal) {
                errors.transactionType = 'Transaction Type is required in Modal';
            }
        }
        else {
            if(!inputData.transactionType) {
                errors.transactionType = 'Transaction Type is required';
            }
        }

        return errors;
      }

      useEffect(() => {
        const controller = new AbortController();
        const signal = controller.signal;
        getTransactionTypeData(signal);

        return () => {
            controller.abort();
        }
      },[]);


     // Get TransactionData from API
    const getTransactionTypeData = async (signal) => {
        dispatch(setIsLoading(true))

        try {
            const result = await getTransactionTypeService(signal);
            if(result.data) {
                setTransactionTypeData(result.data)
            }
        } catch (error) {
            const errorMessage =
                error?.response?.data?.error?.includes('streaming buffer')
                    ? 'BigQuery streaming buffer:  Please Wait some minutes and try again later'
                    : error?.response?.data?.message || error?.message;

            dispatch(
                setToastMessage({
                    message: errorMessage,
                    type: "error",
                })
            );
        } finally {
        dispatch(setIsLoading(false))
        }
    }

    const createAction = async () => {
      dispatch(setIsLoading(true))

      try {
        let result;

          result = await createTransactionTypeService({
            ...inputData
          // ,permission
        })

        if(result.data) {
          if(showEdit) {
            setTransactionTypeData(transactionTypeData.map(obj => obj.transactionTypeId === result.data.transactionTypeId ?
                result.data
                : obj));
          }
          else
          {
              transactionTypeData.push(result.data);
          }
          formReset();
        }
        } catch (error) {
                const errorMessage =
                    error?.response?.data?.error?.includes('streaming buffer')
                        ? 'BigQuery streaming buffer:  Please Wait some minutes and try again later'
                        : error?.response?.data?.message || error?.message;

                dispatch(
                    setToastMessage({
                        message: errorMessage,
                        type: "error",
                    })
                );
            } finally {
        dispatch(setIsLoading(false))
      }
    }


  return (
    <>
      <div className='flex justify-center h-[88vh] w-full'>
          <div className='h-full w-full md:w-[95%] text-sm'>

              {/* Game Type Header */}
              <div className='py-4 pl-1 flex gap-2'>
                  <img src={GameTypeIcon} alt="" />
                  <span className='text-fgColor font-semibold'>Transaction Type</span>
              </div>

              {/* Create new Transaction input including formsubmit */}
              <div className='w-full h-[85%] bg-rectangle rounded-sm pb-10'>
                  <form onSubmit={handleSubmit}
                  className='flex items-center h-20 w-[93%] pl-5 m-auto border-b-2 border-borderColor gap-2'>
                    <div>
                      <input type="text" className='w-[210px] bg-textbgcol px-3 py-2 rounded-sm font-semibold mt-3 outline-none' placeholder='Transaction Type' name='transactionType'
                          onChange={(e) => setInputData({...inputData, transactionType: e.target.value})} value={inputData.transactionType}
                          />

                          {errors.transactionType && !showEdit && <p className='text-red text-xs font-bold'>{errors.transactionType}</p>}
                    </div>

                      <button type="submit" className='bg-primary w-[110px] px-3 py-2 text-center font-semibold text-white rounded-md mt-3 cursor-pointer'>Save</button>
                  </form>

                  {/* transactionType Table */}
                  <div className="h-[88%] overflow-y-auto">
                      { transactionTypeData && (
                        <table className='w-full md:w-[85%] m-auto mt-5 text-fgColor font-semibold overflow-y-auto'>
                          <thead>
                              <tr className='border-b-2 border-borderColor m-auto'>
                                  <th className='w-[20%] text-left px-5 md:px-7 py-3'>No.</th>
                                  <th className='w-[25%] text-left px-5 md:px-7 py-3'>Transaction Type</th>
                                  <th className='w-[30%] text-center px-5 md:px-7 py-3'>Action</th>
                              </tr>
                          </thead>
                          <tbody className=''>
                              { transactionTypeData.map((item, index) => (
                                  <tr className='border-b-2 border-borderColor' key={index}>
                                      <td className='w-[20%] text-left px-5 md:px-7 py-3'>{index + 1}</td>
                                      <td className='w-[25%] text-left px-5 md:px-7'>{ item.transactionType }</td>
                                      <td className='w-[30%] text-center px-5 md:px-7'>
                                          <button className='bg-primary px-12 py-2 text-white rounded-md font-semibold cursor-pointer' onClick={() => handleEditClick(item)}>Edit</button>
                                      </td>
                                  </tr>
                              ))}
                          </tbody>
                      </table>
                      )}
                  </div>

                  {/* Edit transactionType input including formsubmit */}
                  {showEdit && (
                          <form onSubmit={handleSubmitModal} className="fixed inset-0 bg-textcol bg-opacity-30 backdrop-blur-sm flex justify-center items-center">
                              <div className="flex flex-col justify-center items-center w-[390px] h-[210px] bg-white rounded-lg">
                                  <div >
                                      <input
                                          type="text"
                                          onChange={(e) => setInputModal({...inputModal, transactionType: e.target.value})}
                                          value={inputModal.transactionType}
                                          className='w-[210px] bg-textbgcol px-3 py-2 rounded-md font-semibold mt-8 outline-none'
                                      />
                                      {errors.transactionType && showEdit && <p className='text-red text-xs font-bold'>{errors.transactionType}</p>}
                                  </div>


                                  <div className="flex justify-end items-center w-[80%] h-[35px] mt-5 select-none">
                                      <button className="px-5 py-2 mr-2 text-white bg-primary rounded-lg cursor-pointer" type='submit'
                                      >Save</button>
                                      <button className="px-5 py-2 mr-2 text-white bg-primary rounded-lg cursor-pointer" onClick={() => setShowEdit(false)}>Cancel</button>
                                  </div>
                              </div>
                          </form>
                      )}
              </div>
          </div>
      </div>
  </>
  )
}

export default Transaction
